var map = {
	"./home_1.png": "gh75",
	"./home_2.png": "jXkq",
	"./home_3.png": "kbTp",
	"./home_4.png": "n/Sd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9fx";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/home_.*\.png$
// module id = d9fx
// module chunks = 0